<template>
    <rkm-modal
        large
        ref="Modal"
        title="Especialidades"
    >
        <Form :prestador="prestador" />
        <List :prestador="prestador" />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalPrestador: null,
        prestador: null,
    }),
    methods: {
        open(prestador) {

            this.originalPrestador = prestador
            this.prestador = this.clone(prestador)

            this.$refs.Modal.show()
        },
        save() {

            this.originalPrestador.especialidades = this.prestador.especialidades

            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    mixins: [object],
}
</script>